import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { NotificationCounts, SidebarResponse, User } from '@cyphex/types';
import { QUERY_KEYS } from '@/constants/queryKeys';
import { shellApi } from '@/lib/api/shell';

const VIEWER_STALE_MS = 5 * 60_000;
const SIDEBAR_STALE_MS = 60_000;
/** Counts arrive over the WebSocket; the fetch is only a cold-start snapshot. */
const COUNTS_STALE_MS = 60_000;

export function useViewer(): UseQueryResult<User> {
  return useQuery({
    queryKey: QUERY_KEYS.viewer(),
    queryFn: ({ signal }) => shellApi.getViewer(signal),
    staleTime: VIEWER_STALE_MS,
  });
}

export function useSidebar(): UseQueryResult<SidebarResponse> {
  return useQuery({
    queryKey: QUERY_KEYS.sidebar(),
    queryFn: ({ signal }) => shellApi.getSidebar(signal),
    staleTime: SIDEBAR_STALE_MS,
  });
}

export function useNotificationCounts(): UseQueryResult<NotificationCounts> {
  return useQuery({
    queryKey: QUERY_KEYS.notificationCounts(),
    queryFn: ({ signal }) => shellApi.getNotificationCounts(signal),
    staleTime: COUNTS_STALE_MS,
  });
}
